import {OrganismeFichierType} from '@common/services';

export const FILE_TYPE_COLORS: Record<OrganismeFichierType, string> = {
  [OrganismeFichierType.ATTESTATION_REPRESENTANT]: '#4AD0F1',
  [OrganismeFichierType.DELEGATION_POUVOIR]: '#6A6AF4',
  [OrganismeFichierType.HABILITATION]: '#000091',
};